// /invite/:token — «Задайте пароль» по ссылке-приглашению. 020 (T031): next — куда перейти после
// пароля; страница пропускает только адрес протокола (/protocols/<номер>), иначе — главная.
import { createFileRoute } from '@tanstack/react-router';
import { InvitePage } from '../features/auth/InvitePage.tsx';

export const Route = createFileRoute('/invite/$token')({
  validateSearch: (search: Record<string, unknown>): { next?: string } =>
    typeof search.next === 'string' ? { next: search.next } : {},
  component: InviteRoute,
});

function InviteRoute() {
  const { token } = Route.useParams();
  const { next } = Route.useSearch();
  return <InvitePage token={token} next={next} />;
}
